import { render } from "./HomePrincipal.vue?vue&type=template&id=4782e5c8"
import script from "./HomePrincipal.vue?vue&type=script&lang=js"
export * from "./HomePrincipal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__